<template>
    <a id="CTAButton" ref="CTAButton" :href="link" class="cta-button" :class="[level]" @click="$emit('onClick')">
        <div class="cta-content">
            <span class="cta-button-text">{{ mainText }}</span>
            <div class="cta-button-icon-content">
                <span class="cta-button-icon-content-hidden-text">{{ hiddenText }}</span>
                <span class="cta-button-icon-content-icon icon-Right"></span>
            </div>
        </div>
    </a>
</template>
<script>

/* eslint-disable */
export default {
    name: 'cta-button',
    props: {
        link: {
            require: false,
            type: String
        },
        level: {
            require: true,
            type: String
        },
        text: {
            require: true,
            type: String,
        },
        hiddentext: {
            require: true,
            type: String,
        },
        breakpoints: {
            require: false,
            type: Array,
            default: () => ([])
        },
    },
    methods: {
        /**
         * Retona el texto específico para el tamaño del dispositvo actual
         * 
         * @author Óscar
         */
        getBreakpoinTextBy (property = 'text') {
            let text = '';
            this.sortedBreakpoints.forEach(breakpoint => {
                if (window.outerWidth <= breakpoint.window) {
                    text = breakpoint[property];
                }
            })
            return text;
        }
    },
    computed: {
        /**
         * Orderna de forma descendiente los breakpoints solicitados
         * 
         * @author Óscar
         */
        sortedBreakpoints: function() {
            if (this.breakpoints.length) {
                return [...this.breakpoints].sort((a, b) => b.breakpoint - a.breakpoint);
            }
            return [];
        },
        /**
         * Determina cual será el texto a mostrar dependiendo del tamaño del dispositivo
         * 
         * @author Óscar
         */
        mainText () {
            return this.getBreakpoinTextBy('text') || this.text
        },
        /**
         * Determina cual será el texto escondido a mostrar dependiendo del tamaño del dispositivo
         * 
         * @author Óscar
         */
        hiddenText () {
            return this.getBreakpoinTextBy('hiddentext') || this.hiddentext
        },
    }
}
</script>
<style lang="scss" scoped>
    .cta-button {
        &.shadow-button {
            box-shadow: 0 0 10px rgb(104 104 104 / 21%);
        }
        &.border-button {
            border: 2px solid #686868;
        }
        border-radius: 50px;
        color: #686868;
        display: inline-block;
        font-size: 1rem;
        font-weight: bold;
        padding: 16px 59px 16px 30px;
        position: relative;
        background: white;
        .cta-content {
            align-items: center;
            display: flex;
        }
        &-text,
        &-icon-content {
            display: inline-block;
        }
        &-text {
            margin-right: 21px;
            transition: transform 200ms ease-in-out, opacity 100ms ease-in-out;
        }
        &-icon-content {
            align-items: center;
            border-radius: 50px;
            color: white;
            display: flex;
            justify-content: center;
            height: 42px;
            width: 42px;
            position: absolute;
            right: 6px;
            transition: all 200ms ease-in-out;
            .cta-button-icon-content-hidden-text {
                visibility: hidden;
                opacity: 0;
                transition: all 300ms ease-in 200ms, visibility 1ms;
            }
            .icon-Right {
                position: absolute;
                right: 13px;
                transition: visibility 200ms ease-in, opacity 200ms ease-out;
            }
        }
        &.info {
            .cta-button-icon-content {
                background-color: #00A1C9;
            }
        }
        &.success {
            .cta-button-icon-content {
                background-color: #73C914;
            }
        }

        &.black {
            color: #000;

            .border-button {
                border: 2px solid #000;
            }

            .cta-button-icon-content {
                background-color: #000;
            }
        }
        &:hover {
            text-decoration: none;
            &.border-button {
                border-color: transparent;
                cursor: pointer;
            }
            .cta-button-text {
                opacity: 0;
                transform: translateX(6px);
            }
            .cta-button-icon-content {
                border-radius: 50px;
                height: 100%;
                right: 0;
                width: 100%;
                .cta-button-icon-content-hidden-text {
                    visibility: visible;
                    opacity: 1;
                }
                .icon-Right {
                    visibility: hidden;
                    opacity: 0;
                }
            }
        }
    }
</style>
